<template>
  <v-dialog v-model="dialog" activator="" fullscreen attach="">
    <template v-slot:activator="{ on, attrs }">
      <v-btn rounded color="teal" v-on="on" v-bind="attrs" block text dark>
        <v-icon left>mdi-draw-pen</v-icon> Assinar Pedido</v-btn
      >
    </template>
    <v-card>
      <v-toolbar color="primary" max-height="56" dark>
        <v-btn icon @click="dialog = false"
          ><v-icon>mdi-arrow-left</v-icon></v-btn
        >
        <v-toolbar-title>Assinatura do cliente</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4 assinatura-dialog__content">
        <v-overlay v-if="bloquearAssinatura()" opacity=".8">
          <v-row>
            <v-col cols="12" class="text-center">
              <span class="title pa-2"
                >Utilize o modo paisagem para assinar seu pedido</span
              >
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn @click="dialog = false" color="info">OK</v-btn>
            </v-col>
          </v-row>
        </v-overlay>
        <v-row>
          <v-col cols="6">
            <v-btn
              rounded
              @click="limpar()"
              :disabled="!signatureReady"
              outlined
              block
              class="mb-3"
              height="30"
              color="error"
            >
              <v-icon left>mdi-close</v-icon> Limpar</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn
              rounded
              color="success"
              outlined
              @click="confirmarAssinatura()"
              :disabled="!signatureReady"
              block
              height="30"
            >
              <v-icon left>mdi-check</v-icon>Confirmar</v-btn
            >
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <VPerfectSignature
              v-if="signatureReady"
              :stroke-options="strokeOptions"
              ref="signaturePad"
              id="signature"
              class="mt-1 assinatura-canvas"
              :height="heightAssinatura()"
              width="100%"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VPerfectSignature from "v-perfect-signature";
import { mapMutations, mapState } from "vuex";
export default {
  components: {
    VPerfectSignature,
  },
  data: () => ({
    dialog: false,
    signatureReady: false,
    resizeTimeoutId: null,
    strokeOptions: {
      size: 7.5,
      thinning: 0.5,
      smoothing: 0.5,
      streamline: 0.5,
    },
  }),
  computed: mapState("pedidos", ["novopedido"]),
  watch: {
    dialog(value) {
      if (value) {
        this.prepararCanvasAssinatura();
        window.addEventListener("resize", this.ajustarCanvasAssinatura);
        window.addEventListener(
          "orientationchange",
          this.ajustarCanvasAssinatura
        );
      } else {
        this.removerEventosCanvas();
      }
    },
  },
  methods: {
    ...mapMutations("sistema", ["setErrorRequest", "setMsgError"]),
    limpar() {
      if (!this.$refs.signaturePad) return;
      this.$refs.signaturePad.clear();
      this.novopedido.assinatura = "";
    },
    confirmarAssinatura() {
      if (!this.$refs.signaturePad) return;
      if (this.$refs.signaturePad.isEmpty()) {
        this.setErrorRequest(true);
        this.setMsgError("Assinatura inválida");
      } else {
        this.novopedido.assinatura = this.$refs.signaturePad.toDataURL();
        this.dialog = false;
      }
    },
    ajustarCanvasAssinatura() {
      this.prepararCanvasAssinatura();
    },
    prepararCanvasAssinatura() {
      clearTimeout(this.resizeTimeoutId);
      this.signatureReady = false;

      this.$nextTick(() => {
        this.resizeTimeoutId = setTimeout(() => {
          if (this.dialog) this.signatureReady = true;
        }, 300);
      });
    },
    heightAssinatura() {
      return this.emPaisagem() ? "55vh" : "40vh";
    },
    emPaisagem() {
      const orientation = window.screen.orientation;
      if (orientation && orientation.type) {
        return orientation.type.toLowerCase().startsWith("landscape");
      }

      return window.innerWidth > window.innerHeight;
    },
    removerEventosCanvas() {
      clearTimeout(this.resizeTimeoutId);
      this.resizeTimeoutId = null;
      this.signatureReady = false;
      window.removeEventListener("resize", this.ajustarCanvasAssinatura);
      window.removeEventListener(
        "orientationchange",
        this.ajustarCanvasAssinatura
      );
    },
    bloquearAssinatura() {
      return !this.emPaisagem();
    },
  },
  beforeDestroy() {
    this.removerEventosCanvas();
  },
};
</script>

<style>
#signature {
  background-color: rgba(128, 128, 128, 0.39);
  border-radius: 12px;
  display: block;
  max-width: 100%;
  width: 100% !important;
}

.assinatura-dialog__content {
  overflow-x: hidden;
}

.assinatura-canvas {
  margin: 0 auto;
}
</style>
